import React from "react";
import POSNavbar from "../pos/POSNavbar";
import CashSessionStartupModal from "../pos/CashSessionStartupModal";
import { PosSessionPromptProvider } from "../../context/PosSessionPromptContext";

const POSLayout = ({
  children,
  allowPageScroll = false,
  cashSessionAutoPrompt = true,
}) => {
  const [isStartSessionRequested, setIsStartSessionRequested] =
    React.useState(false);
  const [sessionPromptMessage, setSessionPromptMessage] = React.useState("");
  const sessionPromptContextValue = React.useMemo(
    () => ({
      isStartSessionRequested,
      sessionPromptMessage,
      requestStartSession: () => setIsStartSessionRequested(true),
      clearStartSessionRequest: () => setIsStartSessionRequested(false),
      setSessionPromptMessage,
    }),
    [isStartSessionRequested, sessionPromptMessage],
  );

  const shellClassName = allowPageScroll
    ? "flex min-h-screen flex-col bg-gradient-to-br from-slate-50 via-slate-100 to-slate-200 dark:from-slate-950 dark:via-slate-900 dark:to-slate-800 transition-colors duration-200"
    : "flex h-screen flex-col overflow-hidden bg-gradient-to-br from-slate-50 via-slate-100 to-slate-200 dark:from-slate-950 dark:via-slate-900 dark:to-slate-800 transition-colors duration-200";

  const contentClassName = allowPageScroll
    ? "flex flex-1 min-h-0 flex-col"
    : "flex flex-1 min-h-0 flex-col overflow-hidden";

  return (
    <PosSessionPromptProvider value={sessionPromptContextValue}>
      <div className={shellClassName}>
        <POSNavbar onStartSession={() => setIsStartSessionRequested(true)} />
        <div className={contentClassName}>{children}</div>
        <CashSessionStartupModal
          autoPrompt={cashSessionAutoPrompt}
          isOpenRequested={isStartSessionRequested}
          promptMessage={sessionPromptMessage}
          onRequestClose={() => setIsStartSessionRequested(false)}
          onSessionStarted={() => {
            setIsStartSessionRequested(false);
            setSessionPromptMessage("");
          }}
        />
      </div>
    </PosSessionPromptProvider>
  );
};

export default POSLayout;
